import { customElement, GenesisElement } from '@genesislcap/web-core';
import { NotFoundStyles as styles } from './not-found.styles';
import { NotFoundTemplate as template } from './not-found.template';

@customElement({
  name: 'not-found-route',
  template,
  styles,
})
export class NotFound extends GenesisElement {
  public connectedCallback() {
    super.connectedCallback();
    console.debug(`${name} is now connected to the DOM`);
  }
}
